<template>
  <b-input-group slot="right" class="h-100">
    <b-form-input class="h-100" ref="inputLink" v-model="link"></b-form-input>
    <b-btn @click="copyLink" v-b-tooltip.hover title="Copy link" variant="primary"><icon name="copy"></icon></b-btn>
  </b-input-group>
</template>
<script>
  import 'vue-awesome/icons/copy'
  import store from '../../store'
  import Vue from 'vue'
  import WktFormat from 'ol/format/WKT'

  export default {
    name: 'permalink',
    data () {
      return {
        loading: false,
        link: '',
        flag: true
      }
    },
    computed: {
      layers: () => store.getters['map/layersTree'],
      linkShow: {
        get () {
          return this.$store.getters['map/linkShow']
        },
        set (val) {
          this.$store.commit('map/linkShow', val)
        },
      },
      currentWorkpackId: () => store.getters['project/currentProject'] ? store.getters['project/currentProject'].workpack.id : null
    },
    watch: {
      linkShow (val) {
        if (val) {
          this.generateLink()
        }
      }
    },
    mounted () {
      if (this.$route.params['token']) {
        this.$http.get('/api/layers/get-link', {
          params: {
            token: this.$route.params['token']
          }
        }).then(res => {
          if (res.body.wkt) {
            let wktFmt = new WktFormat()
            let geom = wktFmt.readGeometryFromText(res.body.wkt)
            let bbox = geom.getExtent()
            this.$mapService.map.getView().fit(bbox, {
              padding: [10, 10, 10, 10],
              maxZoom: 16
            })
          } else if (res.body.center) {
            this.$mapService.map.getView().setCenter(res.body.center)
            this.$mapService.map.getView().setResolution(res.body.resolution)
            this.$mapService.map.getView().setRotation(res.body.rotation)
          }

          store.commit('map/permaLayers', res.body.layers)
          store.commit('map/permaLabels', res.body.labels)

          if (res.body.profile) {
            store.commit('map/permaProfile', res.body.profile)
          }

        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not find perma link',
            type: 'error'
          })
        })
      }
    },
    methods: {
      generateLink () {
        let layerMap = {}
        let payload = {}
        this.$mapService.walkTree(this.layers, l => {
          layerMap[l['name']] = l['checked']
        })
        // TODO: filter unneeded layers from map
        payload['layers'] = layerMap
        payload['labels'] = this.$store.getters['map/renderedLabelsMap']
        payload['resolution'] = this.$mapService.map.getView().getResolution()
        payload['center'] = this.$mapService.map.getView().getCenter()
        payload['rotation'] = this.$mapService.map.getView().getRotation()

        this.loading = true
        this.$http.post('/api/layers/save-link/', {
          data: JSON.stringify(payload)
        })
          .then(res => {
            this.link = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/' + this.currentWorkpackId + '/' + res.body.token
            this.loading = false
            Vue.nextTick(() => {
              this.$refs.inputLink.$el.focus()
              this.$refs.inputLink.$el.select()
            })
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not save link',
              type: 'error'
            })
            this.loading = false
          })
      },
      copyLink () {
        let onError = () => {
          this.$notify({
            title: 'WARNING',
            text: 'Could not copy link to clipboard. Please, copy it manually',
            type: 'warning'
          })
        }
        try {
          let successful = document.execCommand('copy')

          if (successful) {
            this.linkShow = false
            this.$notify({
              title: 'Link Copied',
              text: 'Link is now available from your clipboard',
              type: 'success'
            })
          } else {
            onError()
          }
        } catch (err) {
          onError()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/Permalink.vue